<template>
    <div class="back-btn-wrap">
        <button v-if="mode === 'game'" class="icon-btn" type="button" aria-label="Back" @click="toggleMenu">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <line x1="19" y1="12" x2="5" y2="12" /> <polyline points="12 19 5 12 12 5" /> </svg>
        </button>
        <button v-else class="icon-btn" type="button" aria-label="Back" @click="goBack">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <line x1="19" y1="12" x2="5" y2="12" /> <polyline points="12 19 5 12 12 5" /> </svg>
        </button>

        <transition name="menu-pop">
            <div v-if="menuOpen" class="back-menu">
                <span class="back-menu-caret" />

                <button class="back-menu-item back-menu-item--leave" type="button" @click="onLeaveLobby">
                    <svg class="back-menu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                        <polyline points="10 17 15 12 10 7" />
                        <line x1="15" y1="12" x2="3" y2="12" />
                    </svg>
                    <span>Leave Lobby</span>
                </button>

                <button class="back-menu-item back-menu-item--end" type="button" @click="onEndGame">
                    <svg class="back-menu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="9" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                    </svg>
                    <span>End Party</span>
                </button>
            </div>
        </transition>
    </div>

</template>

<script>

export default {
    name: 'back',
    components: {
    },
    props: {
        goBack: Function,
        mode: String
    },
    data() {
        return {
            menuOpen: false
        }
    },
    computed: { },
    methods: {
        goToDetails(){
        },
        toggleMenu(){
            this.menuOpen = !this.menuOpen
        },
        async onLeaveLobby(){
            this.menuOpen = false
            if(this.$parent.pickedPlayer){
                await window.afetch('/party/removePlayer', {
                    method: 'POST',
                    body: JSON.stringify({
                        player: this.$parent.pickedPlayer,
                        user: window.localStorage.getItem('cid')
                    }),
            })

            }
            this.$router.push('/games')
        },
        onEndGame(){
            this.menuOpen = false
            this.goBack()
        }
    },
}
</script>

<style lang="scss" scoped>
.back-btn-wrap {
    position: relative;
    display: inline-block;
}

.back-menu {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 20;
    min-width: 176px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    background: #363638;
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-radius: 12px;
    transform-origin: top left;
}

.back-menu-caret {
    position: absolute;
    top: -5px;
    left: 14px;
    width: 10px;
    height: 10px;
    background: #363638;
    transform: rotate(45deg);
}

.back-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 9px 10px;
    background: transparent;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.01em;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;

    &:active {
        transform: scale(0.98);
    }
}

.back-menu-icon {
    flex: none;
    width: 16px;
    height: 16px;
}

.back-menu-item--leave {
    color: #f2f2f4;

    &:hover,
    &:focus-visible {
        background: rgba(255, 255, 255, 0.08);
    }
}

.back-menu-item--end {
    color: #ff5c5c;

    &:hover,
    &:focus-visible {
        background: rgba(255, 92, 92, 0.12);
        color: #ff7a7a;
    }
}

.menu-pop-enter-active {
    transition: opacity 0.14s ease, transform 0.14s ease;
}

.menu-pop-leave-active {
    transition: opacity 0.1s ease, transform 0.1s ease;
}

.menu-pop-enter-from,
.menu-pop-leave-to {
    opacity: 0;
    transform: scale(0.94) translateY(-4px);
}
</style>
